import React from 'react';
import { AiFillStar } from 'react-icons/ai';

const AssessmentRating = ({ score }) => {
    // Handle case where score is null or undefined
    if (score === null || score === undefined) {
        return (
            <div className="assessment-rating">
                <span className="rating-text">? ⭐</span>
            </div>
        );
    }

    if (typeof score !== 'number' || score < 0 || score > 100) {
        return <div>Invalid score</div>;
    }

    const maxScore = 100;
    const maxRating = 5;

    // Calculate rating out of 5 based on the score
    const rating = (score / maxScore) * maxRating;

    return (
        <div className="assessment-rating">
            <span className="rating-text" style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                {rating.toFixed(1)}
                <AiFillStar style={{ color: '#6ebe44', fontSize: 18 }} />
            </span>
        </div>

    );
};

export default AssessmentRating;
